import * as React from 'react';
import { RiLogoutBoxRLine } from '@remixicon/react';
import { Link } from '@tanstack/react-router';

export default function Header() {
  return <div className="fixed w-full top-0 left-0 flex flex-row items-center header p-4">
    <div className="flex-1/4">
      <div className="flex py-4 flex-row items-center">
        <img src="/public/shoppy-logo.svg" />
        <div className="ml-2">
          Shoppy Admin
        </div>
      </div>
    </div>
    <div className="flex-1/2">
      <div className="flex justify-center">
        <Link className="text-lg p-4" to="/categories">Categories</Link>
        <Link className="text-lg p-4" to="/products">Products</Link>
        <Link className="text-lg p-4" to="/query-suggestions">Query Suggestions</Link>
      </div>
    </div>
    <div className="flex-1/4">
      <div className="flex justify-end">
        <a className="p-4" href="/oauth/logout">
          <RiLogoutBoxRLine />
        </a>
      </div>
    </div>
  </div>;
}
